export default {
  IS_CHANGE_STATUS: false
};



// WEBPACK FOOTER //
// ./src/util/call/klcns/klcnsAPI/klcnsCommon.js